import type { EntitySection } from '@/lib/entity-sections';

/*
 * Domain knowledge: the sub-sections a TPA detail view exposes. Lives in the
 * feature (EntitySectionLayout and lib/entity-sections are domain-free). Ported
 * verbatim from the prototype's `ENTITY_SECTIONS['tpas']`
 * (public/js/entity-sub-menu.js) so existing deep links keep working; `profile`
 * is the first section and the fallback.
 */
export const tpaSections: readonly EntitySection[] = [
  { id: 'profile', label: 'Profile' },
  // Users section (F02 R20, AC-5f7370f6): manage the organization's user
  // accounts from its own record. Composed at the route (routes → features) so
  // the tpas feature does not import the users feature (a features→features
  // boundary); see tpas/$tpaId/$section.tsx.
  { id: 'users', label: 'Users' },
  // Notifications section (F02 R27/R28/R29): the administrator on-behalf
  // notification surface and its change history for a chosen user of this
  // organization (AC-7aaa025f, AC-bf8668ea). Composed at the route (routes →
  // features) so the tpas feature imports neither the users nor the portal
  // feature.
  { id: 'notifications', label: 'Notifications' },
  { id: 'commissions', label: 'Commissions' },
  { id: 'contracts', label: 'Contracts' },
  { id: 'bank-accounts', label: 'Bank Accounts' },
  { id: 'disbursement-schedules', label: 'Disbursement Schedules' },
  { id: 'distribution-rules', label: 'Distribution Rules' },
];
